// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"432":"0b091a07","754":"b294284d"}[chunkId] + ".chunk.js";
};